import React from 'react'
import { injectIntl } from 'react-intl'

class QuoteHelper {

    static getStatusName(intl, status, isInternal) {
        switch (status) {
            case 'new':
                return intl.formatMessage({
                    id: "quote.status.new_label",
                    defaultMessage: "New",
                })
            case 'draft':
                return intl.formatMessage({
                    id: "quote.status.draft_label",
                    defaultMessage: "Draft",
                })
            case 'cancelled':
                return intl.formatMessage({
                    id: "quote.status.cancelled_label",
                    defaultMessage: "Cancelled",
                })
            case 'proposed':
                return intl.formatMessage({
                    id: "quote.status.proposed_label",
                    defaultMessage: "Proposed",
                })
            case 'pre-approved':
                return intl.formatMessage({
                    id: "quote.status.pre_approved_label",
                    defaultMessage: "Pre-approved",
                })
            case 'pre-declined':
                return intl.formatMessage({
                    id: "quote.status.pre_declined_label",
                    defaultMessage: "Pre-declined",
                })
            case 'approved':
                return isInternal ?
                    intl.formatMessage({
                        id: "quote.status.won_label",
                        defaultMessage: "Won",
                    }) :
                    intl.formatMessage({
                        id: "quote.status.approved_label",
                        defaultMessage: "Approved",
                    })
            case 'declined':
                return isInternal ?
                    intl.formatMessage({
                        id: "quote.status.lost_label",
                        defaultMessage: "Lost",
                    }) :
                    intl.formatMessage({
                        id: "quote.status.declined_label",
                        defaultMessage: "Declined",
                    })
            case 'work-in-progress':
                return intl.formatMessage({
                    id: "quote.status.work_in_progress_label",
                    defaultMessage: "Work in progress",
                })
            case 'work-completed':
                return intl.formatMessage({
                    id: "quote.status.work_completed_label",
                    defaultMessage: "Work completed",
                })
            case 'invoiced':
                return intl.formatMessage({
                    id: "quote.status.invoiced_label",
                    defaultMessage: "Invoiced",
                })
            case 'ordered':
                return intl.formatMessage({
                    id: "quote.status.ordered_label",
                    defaultMessage: "Ordered",
                })
        }
    }

}

export default injectIntl(QuoteHelper)


// WEBPACK FOOTER //
// ./src/quote/quotehelper.jsx